module.exports = __webpack_public_path__ + "img/ill_spot_success_scan_stt.96c12d5c.svg";